<template>
  <!-- Message -->
  <el-collapse-transition>
    <div
      v-if="props.visible"
      :class="['sm-dialog-message', `sm-dialog-message-${props.type}`]">
      <div class="icon">
        <CircleCheck
          v-if="props.type == 'success'"
          :size="20"
          class="text-green" />

        <CircleAlert
          v-else-if="props.type == 'warning'"
          :size="20"
          class="text-orange" />

        <CircleX
          v-else-if="props.type == 'error'"
          :size="20"
          class="text-magenta" />
      </div>
      <div class="message">
        <slot>
          {{ props.message }}
        </slot>
      </div>
    </div>
  </el-collapse-transition>
</template>

<script setup lang="ts">
  import { CircleAlert, CircleCheck, CircleX } from 'lucide-vue-next'

  export type DialogMessageTypes = 'success' | 'error' | 'warning' | 'info'

  export interface SmDialogMessageProps {
    type: DialogMessageTypes
    message?: string
    visible?: boolean
  }

  const props = withDefaults(defineProps<SmDialogMessageProps>(), {
    visible: false,
    message: '',
  })
</script>

<style lang="scss">
  .sm-dialog-message {
    $message-padding: 0.5rem;
    margin: 0;
    padding: $message-padding;
    border-radius: var(--border-radius-base);
    display: flex;
    align-items: center;

    box-sizing: border-box;

    &-success {
      border: 1px solid var(--sm-green);
    }

    &-warning {
      border: 1px solid var(--sm-orange);
    }

    &-error {
      border: 1px solid var(--sm-magenta);
    }

    .message {
      margin-left: 0.5rem;
    }
  }
</style>
